import { useMemo } from 'react';
import { CurrencyUtils } from '@shared/utils';

export const useCurrencySymbol = (code?: string): string => {
  return useMemo(() => {
    if (!code) return '';
    return CurrencyUtils.getSymbolByCode(code) || '';
  }, [code]);
};
